import React from 'react';
import content from '../../../../content/main.archie';
import Markdown from 'react-remarkable';
import {contentToText} from '../../../utils/helpers.jsx';
import PictureFrame from '../../PictureFrame/PictureFrame.jsx';

const IMOPic = (props) => {
    return <div className="imopic">
        <PictureFrame caption="World leaders and U.N. officals raise their hands to celebrate the adoption of climate pact at the COP 21 Climate Conference in Paris on December 12, 2015, from left, Christiana Figueres, Ban Ki Moon, Laurent Fabius and Francois Hollande." credit="François Guillot/Agence France-Presse">
            <img src="images/cop21.jpg" style={{width:"100%"}} />
        </PictureFrame>
    </div>;
}

export default (props) => {
    return (<div className="container body-text">
        <div className="section">
            <div className="row">
                <div className="col l8">
                    <Markdown>
                        {contentToText(content['climate-talks'],{
                            imopic: <IMOPic />
                        })}
                    </Markdown>
                </div>
            </div>
        </div>
    </div>)   
}




// WEBPACK FOOTER //
// ./src/js/components/special/ClimateTalks/ClimateTalks.jsx